import axios from 'axios'
import {EDIT_BRANCH, COPY_BRANCH, CREATE_BRANCH, NOTIFICATION_DANGER, NOTIFICATION_INFO} from '../../constants/common'
import _ from 'lodash'

// initial state
const state = {
    loading: false,
    activeList: {},
    fullScreen: false,
    common: [],
    personal: [],
    visibleControlsId: null,
    controlType: false,
    activeBranch: false,
};

// getters
const getters = {
    selectedCount: state => {
        let count = 0;
        state.activeList.items.forEach((item) => {
            if (item.checked) {
                count++
            }
        });

        return count
    },
    getPersonalBranch: state => id => {
        let branch = state.personal.find(x => x.id === id);
        if (!branch) {
            branch = state.common.find(x => x.id === id);
        }
        return branch
    }
};

// actions
const actions = {
    saveBranch({commit}) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/people-test.json')
                    .then(() => {
                        commit('saveBranch');
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },1000);
        });
    },
    pushBranch({commit}) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.get('/api/people-test.json')
                    .then(() => {
                        commit('pushBranch');
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()
            },1000);
        });
    },
    setEdit({commit}, type) {
        commit('setEditType', type);
        this.commit('setNavVisible', false);
    },
    copyBranch({commit, dispatch}, id) {
        commit('copyToActiveBranch', id);
        dispatch('setActiveList', {});
        commit('setCopy');
    },
    createBranch({commit, dispatch}) {
        commit('createBranch');
        dispatch('setEdit', CREATE_BRANCH);
        dispatch('setActiveList', {});
    },
    editBranch({commit, dispatch}, id) {
        commit('setActiveBranch', id);
        dispatch('setActiveList', {});
        commit('setEdit', id);
    },
    deleteBranch({commit}, id) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.post('/test/post-request/', {id:id })
                    .then(() => {
                        commit('deleteBranch', id);
                        this.dispatch('pushNotification', {type: NOTIFICATION_INFO, text: "Ветка удалена", time: 50000})
                    })
                    .catch((response) => {
                        console.log(response);
                    });
                resolve();
            },300);
        });
    },
    deleteList({commit}, id) {
        return new Promise((resolve) => {
            setTimeout(() => {
                axios.post('/test/post-request/', {id:id })
                    .then(() => {
                        commit('deleteList', id);
                        this.dispatch('pushNotification', {type: NOTIFICATION_INFO, text: "Чек-лист удален", time: 50000})
                    })
                    .catch((response) => {
                        console.log(response);
                    });
                resolve();
            },300);
        });
    },
    setFavorite({commit}, id) {
        return new Promise((resolve) => {
            setTimeout(function () {
                commit('setFavorite', id);
                resolve()
            },100);
        });
    },
    deselectAll({commit}) {
        commit('deselectAll');
    },
    setActiveList({commit}, list) {
        commit('setActiveList', list);
        !_.isEmpty(list) ? this.commit('setNavVisible', false) : this.commit('setNavVisible', false);
    },
    getList({dispatch}, id) {
        axios.get('/api/check-lists-one.json?id='+id)
            .then((response) => {
                dispatch('setActiveList', response.data.list);
            })
            .catch((response) => {
                console.log(response);
                this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
            });
    },
    getLists({commit}) {
        commit('setCommon', []);
        commit('setLoading', true);
        //todo: для симуляции загрузки, потом удалить
        setTimeout(() => {
            axios.get('/api/check-lists.json')
                .then((response) => {
                    commit('setCommon', response.data.branches.common);
                    commit('setPersonal', response.data.branches.personal);
                    commit('setLoading', false);
                })
                .catch((response) => {
                    console.log(response);
                    this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                });
        },1000);
    },
    changeListItem({commit}) {
        return new Promise((resolve) => {
            setTimeout(function () {
                commit('fake');
                resolve()
            },500);
        });
    },
    setFavoriteList({commit}) {
        return new Promise((resolve) => {
            setTimeout(function () {
                commit('fake');
                resolve()
            },1000);
        });
    },

};

// mutations
const mutations = {
    setPersonalLists (state, items) {
        //let branch = state.personal.find(x => x.id === idBranch);
        //branch.lists = items
        state.activeBranch.lists = items
    },
    setPersonalBranches (state, items) {
        state.personal = items
    },
    deselectAll (state) {
        state.activeList.items.forEach((item) => {
            item.checked = false
        });
    },
    setActiveList (state, list) {
        state.activeList = list;
        //state.controlType = false;
    },
    setFullScreen (state, value) {
        state.fullScreen = value;
    },
    setCommon (state, lists) {
        state.common = lists
    },
    setPersonal (state, lists) {
        state.personal = lists
    },
    setControlsVisibility(state, id){
        state.visibleControlsId = id;
    },
    setLoading(state, value) {
        state.loading = value;
    },
    setVersions(state, versions) {
        state.currentPostVersions = versions
    },

    deleteBranch(state, id) {
        let index = state.personal.findIndex(x => x.id === id);
        state.personal.splice(index ,1)
    },

    deleteList(state, id) {
        state.personal.forEach((branch) => {
            let index = branch.lists.findIndex(x => x.id === id);
            if (index > -1) {
                branch.lists.splice(index, 1)
            }
        });
    },
    setFavorite(state, id) {
        let index = -1;
        state.common.forEach((branch) => {
            let i = branch.lists.findIndex(x => x.id === id);
            if (i !== -1) {
                let newList = branch.lists[i];
                newList.favorite = !newList.favorite;
                branch.lists.splice(i, 1, newList )
            }
        });
        if (index === -1) {
            state.personal.forEach((branch) => {
                let i = branch.lists.findIndex(x => x.id === id);
                if (i !== -1) {
                    let newList = branch.lists[i];
                    newList.favorite = !newList.favorite;
                    branch.lists.splice(i, 1, newList )
                }
            });
        }
    },

    setActiveBranch(state, id) {
        let branch = state.personal.find(x => x.id === id);
        if (!branch) {
            branch = state.common.find(x => x.id === id);
        }
        state.activeBranch = branch
    },
    createBranch(state) {
        state.activeBranch = {
            id: 4534522,
            title: "",
            lists: [],
            total: 0,
            count: 0
        };
        //state.activeBranch = branch
    },
    copyToActiveBranch(state, id) {
        let branch = state.personal.find(x => x.id === id);

        if (!branch) {
            branch = state.common.find(x => x.id === id);
        }

        branch = Object.assign({}, branch);
        branch.id = 4534522;

        branch.lists.forEach((item) => {
           item.checked = true;
        });
        state.activeBranch = branch
    },
    copyListsToActiveBranch(state, lists) {

        state.activeBranch.lists = state.activeBranch.lists.concat(lists)
    },
    setEditType(state, type) {
        state.controlType = type;
        //state.activeList = true;
    },
    setEdit(state) {
        state.controlType = EDIT_BRANCH;
        //state.activeList = true;
    },
    setCopy(state) {
        state.controlType = COPY_BRANCH;
        //state.activeList = true;
    },
    closeEdit(state) {
        state.controlType = false;
        state.activeList = false;
    },
    pushBranch(state) {
        let branch = Object.assign({}, state.activeBranch);
        branch.lists = [];

        state.activeBranch.lists.forEach((item) => {
           if (item.checked) {
               branch.lists.push(Object.assign({},item))
           }
        });

        state.personal.push(branch);

        //state.activeBranch = null;
        state.activeList = false;
    },
    saveBranch() {

    },
    fake() {

    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}